const PLATFORM_ICON_MAP: Record<string, string> = {
  OpenAI: 'ico--gpt-bck',
  ChatGPT: 'ico--gpt-bck',
  Anthropic: 'ico--claude-bck',
  Claude: 'ico--claude-bck',
  Google: 'ico--gemini-bck',
  Gemini: 'ico--gemini-bck',
  Perplexity: 'ico--perplexity-bck',
  xAI: 'ico--grok-bck',
  Grok: 'ico--grok-bck',
  Microsoft: 'ico--copilot-bck',
  Copilot: 'ico--copilot-bck',
  DeepSeek: 'ico--deepseek-bck',
};

const BOT_ICON_MAP: Record<string, string> = {
  GPTBot: 'ico--gpt-bck',
  'ChatGPT-User': 'ico--gpt-bck',
  'ChatGPT-Search': 'ico--gpt-bck',
  'OAI-SearchBot': 'ico--gpt-bck',
  ClaudeBot: 'ico--claude-bck',
  'Claude-User': 'ico--claude-bck',
  'anthropic-ai': 'ico--claude-bck',
  PerplexityBot: 'ico--perplexity-bck',
  'Perplexity-User': 'ico--perplexity-bck',
  Googlebot: 'ico--gemini-bck',
  'Google-Extended': 'ico--gemini-bck',
  'Gemini-Deep-Research': 'ico--gemini-bck',
  GoogleOther: 'ico--gemini-bck',
};

/**
 * Returns the `ico--*-bck` mask-image class for a known platform, or `null` when no
 * dedicated brand asset is registered. Callers should treat `null` as "render a generic
 * brand placeholder" (see `BrandIcon` which paints a colored letter badge in that case).
 *
 * Returning `null` rather than a generic fallback class keeps the fallback decision in the
 * consumer — previously a magic `'ico--bot'` string was returned, which forced `BrandIcon`
 * to special-case that exact string to know "this is the unknown sentinel". Splitting the
 * concern fixes that fragile coupling.
 */
export const getPlatformIcon = (name: string): string | null =>
  PLATFORM_ICON_MAP[name] ?? null;

export const getBotIcon = (name: string): string | null => BOT_ICON_MAP[name] ?? null;
